import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        type_name: "",
        type_desc: "",
        param_keys: [],
        status: 1
      },
      copyPramsKeyData: null,
      typeList: [{
        label: "字符串",
        value: "string"
      }, {
        label: "数字",
        value: "number"
      }, {
        label: "布尔值",
        value: "boolean"
      }, {
        label: "字典",
        value: "map"
      }, {
        label: "列表",
        value: "array"
      }],
      typeArrayList: [{
        label: "字典",
        value: "map"
      }],
      typeArrayValue: "map",
      rules: {
        type_name: [{
          required: true,
          message: "母包类型名称",
          trigger: "blur"
        }],
        type_desc: [{
          required: true,
          message: "母包类型描述",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "游戏组状态",
          trigger: "blur"
        }],
        param_keys: [{
          required: true,
          message: "请添加参数",
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data, isCopy) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  datas.param_keys = _this.$utils.transformObject(JSON.parse(datas.param_keys));
                  _this.formData = _objectSpread({}, datas);

                  if (isCopy) {
                    _this.formData.id = "";
                  }
                }

                _this.copyData();

                _this.dialogFormVisible = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.param_keys.push({
        stringKey: '',
        stringVal: '',
        typeValue: 'string',
        mapParams: "",
        mapData: [],
        arrayParams: '',
        arrayData: [],
        numberKey: '',
        numberVal: '',
        booleanKey: '',
        booleanVal: ''
      });
    },
    removeContent: function removeContent(index) {
      // var index = this.formData.param_keys.indexOf(item);
      // if (index !== -1) {
      this.formData.param_keys.splice(index, 1); // }
    },
    removeMapItem: function removeMapItem(index, idx) {
      this.formData.param_keys[index].mapData.splice(idx, 1);
    },
    removeArrayItem: function removeArrayItem(index, idx, k) {
      this.formData.param_keys[index].arrayData[idx].arrChildrenItem.splice(k, 1);
    },
    addMapData: function addMapData(index) {
      this.formData.param_keys[index].mapData.push({
        key: "",
        value: ""
      });
    },
    addArrayData: function addArrayData(index) {
      this.formData.param_keys[index].arrayData.push({
        arrChildrenItem: []
      });
    },
    addArrayItemData: function addArrayItemData(index, idx) {
      this.formData.param_keys[index].arrayData[idx].arrChildrenItem.push({
        key: "",
        value: ""
      });
    },
    removeItemContent: function removeItemContent(index, idx) {
      this.formData.param_keys[index].arrayData.splice(idx, 1);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      var PramsKeyData = JSON.parse(JSON.stringify(this.formData.param_keys));
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 12;
                    break;
                  }

                  _this2.reqLoading = true;
                  _context2.next = 4;
                  return _this2.$utils.dealTypeData(PramsKeyData);

                case 4:
                  _this2.copyPramsKeyData = _context2.sent;
                  _context2.next = 7;
                  return _this2.$utils.mergeData(_this2.copyPramsKeyData);

                case 7:
                  _this2.copyPramsKeyData = _context2.sent;
                  data = JSON.parse(JSON.stringify(_this2.formData)); // if (this.formData.id) {
                  //   await this.secondConfirmation()
                  // }

                  data.param_keys = JSON.stringify(_this2.copyPramsKeyData);
                  reqFn = data.id ? 'originPkgTypeUpdate' : 'originPkgTypeAdd';

                  _this2.$api[reqFn](data).then(function (res) {
                    if (res.status == 200) {
                      _this2.$message({
                        message: '操作成功',
                        type: 'success'
                      });

                      _this2.dialogFormVisible = false;

                      _this2.$emit('change');
                    }
                  }).finally(function () {
                    _this2.reqLoading = false;
                  });

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};